<div class="note-item-container">
  <div class="note-item">
    <div class="note-item-inner">
      <div class="comment-preview">
        <div class="comment-preview__header">
          <div class="comment-preview__header-left" *ngIf="note || mentorNote">
            <mat-icon *ngIf="mentorNote" class="mentor-icon">school</mat-icon>
            <p>
              {{
                'translations.global.label.byOn'
                  | transloco
                    : {
                        name: commentAuthor,
                        date: commentCreatedAt,
                      }
              }}
            </p>
          </div>
        </div>

        <ptl-resource-preview class="thin-preview" [previewContent]="content"></ptl-resource-preview>
      </div>
    </div>
  </div>
</div>
